import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../locales/translations';
import { useWarningsSummaryDetailsFormLoaderData } from '../loaders/StudentWarningsSummaryDetailsFormLoader';
import { useWarningsSummaryDetailsLoader } from '../loaders/StudentWarningsSummaryDetailsLoader';
import StudentWarningsSummaryDetailsBlock, {
  StudentWarningsSummaryDetailsBlockProps,
} from './StudentWarningsSummaryDetailsBlock';

const StudentWarningsSummaryDetailsBlocks = () => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_DETAILS);
  const { result } = useWarningsSummaryDetailsLoader();

  const data = useWarningsSummaryDetailsFormLoaderData();

  const items = useMemo(() => {
    if (!result?.success) {
      return [];
    }
    return Object.entries(result.data.warnings).map(
      ([type, warnings]): StudentWarningsSummaryDetailsBlockProps => ({
        name:
          data.warningGroups.find((group) => group.value === type)?.label ??
          type,
        riskLevel:
          result.data.riskLevels[type as keyof typeof result.data.riskLevels],
        warnings: warnings,
      }),
    );
  }, [result, data]);

  const warningsCount = useMemo(() => {
    if (!result?.success) {
      return 0;
    }
    return Object.values(result.data.warnings).reduce(
      (acc, curr) => acc + curr,
      0,
    );
  }, [result]);

  if (!result?.success || !items.length) {
    return <></>;
  }

  return (
    <Container fluid>
      <Row className="pb-4 gutters-filters">
        {items?.map((item, i) => (
          <Col xs={12} sm={6} className="pt-3" md={3} key={i.toString()}>
            <StudentWarningsSummaryDetailsBlock {...item} />
          </Col>
        ))}
        <Col xs={12} sm={6} className="pt-3" md={3}>
          <StudentWarningsSummaryDetailsBlock
            name={t('totalRisk')}
            warnings={warningsCount}
            riskLevel={result?.data?.riskLevel ?? null}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default StudentWarningsSummaryDetailsBlocks;
